import { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';

import { mfaAPI } from 'Backend/users/mfaAPI';
import classes from './NewUserSetupMFA.module.css';
import AuthPageWrapper from 'Components/Auth/AuthPageWrapper/AuthPageWrapper';
import MFA from 'Components/Setup/MFA';
import Button from 'Components/UI_Library/FormElements/Button';
import MfaOkta from 'Components/Setup/MFA/MfaOkta/MfaOkta';
import { isOktaExternalAuthToken } from 'Lib/Utils/authToken';

/** This component acts an interim step for a brand new invited user to be prompted into setting up 2 factor authentication */
const NewUserSetupMFA = () => {
    const [refreshMFA, setRefreshMFA] = useState(false);
    const navigate = useNavigate();

    // If MFA settings have been updated, check they are there and if so redirect to the next screen
    const getMFASettings = async () => {
        const user = await Auth.currentAuthenticatedUser();
        const jwtToken = user?.signInUserSession?.accessToken?.jwtToken;
        const result = await mfaAPI.getMFAsettings({ token: jwtToken });
        if (result?.data?.preferredMfaMethod) {
            navigate('/download-app');
        }
    };

    const tokenType = localStorage.getItem('PTAuthTokenType');

    useEffect(() => {
        if (refreshMFA && !isOktaExternalAuthToken()) {
            getMFASettings();
        }
    }, [refreshMFA, tokenType]);

    return (
        <AuthPageWrapper>
            <div className={classes.centered}>
                <div className={classes.heading}>
                    <h2>Setup 2 factor authentication</h2>
                </div>
                {isOktaExternalAuthToken() ? <MfaOkta /> : <MFA setRefreshMFA={setRefreshMFA} />}
                <Button
                    type="white-condensed"
                    text="Skip for now"
                    href="/download-app"
                    className={classes.skipButton}
                />
            </div>
        </AuthPageWrapper>
    );
};

export default NewUserSetupMFA;
